const CATEGORY_LINKS = ['文娱瓜田', '职场真相', '消费维权', '平台纠纷', '学术与公益', '公共事件'];
const PLATFORM_LINKS = [
  { href: '#board', label: '征集令墙' },
  { href: '#verify', label: '求证工作台' },
  { href: '#steps', label: '提供方式' },
  { href: '#faq', label: '常见问题' },
  { href: '#submit', label: '提供线索 / 求料' },
];

export default function Footer() {
  return (
    <footer id="about" className="bg-accent-950 text-accent-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          {/* about + brand */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-focus-3-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-black tracking-tight text-background-50">寻料站</span>
                <span className="mt-1 text-[10px] font-medium tracking-[0.28em] uppercase text-accent-200/70">
                  XunLiao · 线索征集
                </span>
              </span>
            </div>
            <p className="mt-5 max-w-md text-[14px] leading-relaxed text-accent-200/80">
              寻料站是一个面向内容创作者与热心网友的爆料线索征集与多线索求证平台：发布爆料征集令、公开找爆料线索、
              公开征集关键信息与截图，也让你围观别人如何一步步把瓜坐实。全网寻料求料，让真相多一双眼睛。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              {['爆料征集', '线索征集', '围观求证'].map((tag) => (
                <span key={tag} className="rounded-full border border-accent-100/20 bg-accent-100/5 px-3 py-1 text-[12px] text-accent-100/70">
                  #{tag}
                </span>
              ))}
            </div>
          </div>

          {/* columns */}
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-7">
            <nav aria-label="页脚导航">
              <h4 className="text-[13px] font-bold uppercase tracking-wider text-background-50">平台入口</h4>
              <ul className="mt-4 space-y-2.5 text-[14px]">
                {PLATFORM_LINKS.map((l) => (
                  <li key={l.href}>
                    <a href={l.href} className="text-accent-200/80 transition-colors hover:text-primary-300">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>

            <div>
              <h4 className="text-[13px] font-bold uppercase tracking-wider text-background-50">征集栏目</h4>
              <ul className="mt-4 space-y-2.5 text-[14px]">
                {CATEGORY_LINKS.map((c) => (
                  <li key={c}>
                    <a href="#board" className="text-accent-200/80 transition-colors hover:text-primary-300">
                      {c}线索征集
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-[13px] font-bold uppercase tracking-wider text-background-50">联系与帮助</h4>
              <ul className="mt-4 space-y-2.5 text-[14px] text-accent-200/80">
                <li>
                  <a href="mailto:hello@xunliao-news.cn" className="flex items-center gap-2 transition-colors hover:text-primary-300">
                    <i className="ri-mail-line" aria-hidden="true"></i>
                    hello@xunliao-news.cn
                  </a>
                </li>
                <li>
                  <a href="#faq" className="flex items-center gap-2 transition-colors hover:text-primary-300">
                    <i className="ri-question-line" aria-hidden="true"></i>
                    帮助与常见问题
                  </a>
                </li>
                <li>
                  <a href="#submit" className="flex items-center gap-2 transition-colors hover:text-primary-300">
                    <i className="ri-send-plane-line" aria-hidden="true"></i>
                    提供线索
                  </a>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-line" aria-hidden="true"></i>
                  编辑部工作日 09:00 – 22:00 回复
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-accent-100/15 pt-6 sm:flex-row sm:items-center">
          <p className="text-[13px] text-accent-200/60">© 2026 寻料站 XunLiao. 保留所有权利。</p>
          <p className="max-w-lg text-[12px] leading-relaxed text-accent-200/50">
            本站为线索中转与求证展示平台，不对事件作权威定性，也不承诺任何结论必然属实；涉及纠纷与实名举报请通过官方正规渠道递交。
          </p>
        </div>
      </div>
    </footer>
  );
}